// extracted by mini-css-extract-plugin
export var header = "styles-module--header--a+NL6";
export var logo = "styles-module--logo--Zb2XA";
export var opacity50 = "styles-module--opacity50--E6h7g";